import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import router from '@/router';

export const setAuthToken = (token) => {
  if (token) {
    try {
      const decodedToken = jwtDecode(token);
      const currentTime = Date.now() / 1000;

      if (decodedToken.exp < currentTime) {
        // Token has expired
        localStorage.removeItem('token');
        router.push({ name: 'login' });
        return;
      }

      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } catch (error) {
      console.error('Invalid token:', error);
      localStorage.removeItem('token');
      router.push({ name: 'login' });
    }
  } else {
    delete axios.defaults.headers.common['Authorization'];
  }
};

// Create an Axios instance with baseURL
export const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL, // Replace with your API URL
});

// Add a request interceptor to check for token expiration
api.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        const currentTime = Date.now() / 1000;

        if (decodedToken.exp < currentTime) {
          // Token has expired
          localStorage.removeItem('token');
          router.push({ name: 'login' });
          return Promise.reject('Token expired');
        }

        config.headers.Authorization = `Bearer ${token}`;
      } catch (error) {
        console.error('Invalid token:', error);
        localStorage.removeItem('token');
        router.push({ name: 'login' });
        return Promise.reject('Token decoding failed');
      }
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

//export { api };
